import { Alert, Dropdown } from '@statsbomb/kitbag-components';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import useApi, { API_ENDPOINTS } from '../../hooks/api';

export function InputCompetition({
  competitionId,
  id,
  excludeUnlicensed,
  onChange,
  seasonId,
  sport,
}) {
  const { errorMessage, isFetching, get, response } = useApi();
  const intl = useIntl();

  const includeUnlicensed = !excludeUnlicensed;

  useEffect(() => {
    async function getCompetitions() {
      await get(
        `${
          API_ENDPOINTS.videoService
        }/data/${sport}/competitions?include_unlicensed=${includeUnlicensed.toString()}`,
      );
    }
    getCompetitions();
  }, [sport]);

  const formatOption = ({
    country_name: country,
    competition_id: optionCompetitionId,
    competition_name: name,
    season_id: optionSeasonId,
    season_name: season,
  }) => ({
    label: intl.formatMessage(
      {
        defaultMessage: '{country} {name} {season}',
        id: '26199',
      },
      {
        country,
        name,
        season,
      },
    ),
    value: {
      competitionId: optionCompetitionId,
      seasonId: optionSeasonId,
    },
  });
  const options = (response?.data || []).map(formatOption);

  return (
    <>
      {errorMessage && <Alert type="error">{errorMessage}</Alert>}
      <Dropdown
        id={id}
        isDisabled={isFetching}
        label={intl.formatMessage({
          defaultMessage: 'Lookup Competition',
          id: '74ee4',
        })}
        labelPosition="top"
        onChange={onChange}
        options={options}
        placeholder={intl.formatMessage({
          defaultMessage: 'Lookup Competition',
          id: '74ee4',
        })}
        value={options.find(
          (option) =>
            option.value?.seasonId === seasonId &&
            option.value?.competitionId === competitionId,
        )}
        variant="secondary"
      />
    </>
  );
}

InputCompetition.propTypes = {
  competitionId: PropTypes.string,
  excludeUnlicensed: PropTypes.bool,
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  seasonId: PropTypes.string,
  sport: PropTypes.string.isRequired,
};

InputCompetition.defaultProps = {
  competitionId: undefined,
  excludeUnlicensed: false,
  onChange: () => {},
  seasonId: undefined,
};

export default { InputCompetition };
